import { render, staticRenderFns } from "./IndividualReportPage.vue?vue&type=template&id=67f3963f"
import script from "./IndividualReportPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndividualReportPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports